/**
 * Usage API Service
 * Fetches the calling tenant's current-month Anthropic usage + cost for the
 * sidebar "usage this month" widget.
 */

import api from './api';

export const usageApi = {
  getCurrentMonthUsage: async () => {
    const res = await api.get('/usage/current-month');
    // Backend wraps payloads as { success, data, meta }.
    return res?.data ?? res;
  },
};

export default usageApi;
